import {
  createFeatureFlagsContext,
  type FeatureFlag,
} from 'src/libs/FeatureFlags/createFeatureFlagsContext';

export type Features = FeatureFlag<
  'cm-sg-verified-career-history-notice',
  'on'
>;

export const { useFeatureFlag, FeatureFlagsProvider, featureKeys } =
  createFeatureFlagsContext<Features>(['cm-sg-verified-career-history-notice']);
